import { useState, useEffect} from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./../../styles/admin/LessonPage.css"; 
import jsPDF from "jspdf";
import BASE_URL from "../../BaseUrl";


export default function AssistantLessonPage({setActive,setMobileActive}) {
  const location = useLocation();
  const navigate = useNavigate();
  const {id} = useParams();
  const [lesson, setLesson] = useState({});
  const [loaded , setLoaded] = useState(false);
  const [reload, setReload] = useState(false);
  const [getCodes,setGetCodes] = useState(false)
  const courseId = location.state? location.state.courseId: "";
  const [warning, setWarngin] = useState("error");
  const [showWarning, setShowWarning] =useState(false);
  const [codesToGenerate,setCodesToGenerate] = useState(0);
  const [showCodesPopup, setShowCodePopup] = useState(false);

  const [lessonToEdit, setLessonToEdit] = useState({
        lessonId:id,
        lessonName:"",
        price: 0.00,
    })
    
  const [showEditLessonFrom,setShowEditLessonFrom] = useState(false)



  const updateLesson = ()=>{

          axios.put(`${BASE_URL}/assistant/update-lesson`,lessonToEdit,{withCredentials: true})
          .then((response)=>{
              setLessonToEdit({
                lessonId:id,
                lessonName:"",
                price: 0.00
              })
              setShowEditLessonFrom(false);
              setReload(!reload);
          }).catch((error)=>{
              console.log(error);
          })
      }

  async function getListOfQRCodes(){
    try{
      const respons = await axios.get(`${BASE_URL}/assistant/code?lessonId=${id}&number=12&isQR=1`,{withCredentials:true});
      return respons.data;      
      }catch(error){
        if(error.status === 400){
          alert("الاتصال بالانترنت مقطوع");
        }
      console.log(error);
    }
  }

  async function downloadCodes (){
      const doc = new jsPDF();
      if(codesToGenerate <= 0) return;
      
      try{
        const respons = await axios.get(`${BASE_URL}/assistant/code?lessonId=${id}&number=${codesToGenerate}&isQR=0`,{withCredentials:true});
        // doc.text(respons.data.join("\n"),10,10);
        const margin = 10;
        const pageHeight = doc.internal.pageSize.height;
        const lineHeight = 7;

        let y = margin;

        respons.data.forEach(item => {
          if (y + lineHeight > pageHeight - margin) {
            doc.addPage();
            y = margin;
          }

          doc.text(item, margin, y);
          y += lineHeight;
        });
        setGetCodes(false);
        doc.save(`${lesson.lessonName}.pdf`);
      } catch(error){
        if(error.status === 400) alert("الاتصال بالانترنت مقطوع");
        console.log(error);
      }
    }

  const fetchData = ()=>{
    if(id === null || id === "" || courseId === null || courseId === ""){
        navigate("/assistant-home");
    }
    axios.get(`${BASE_URL}/assistant/lesson?lessonId=${id}&courseId=${courseId}`,{withCredentials: true})
    .then((response)=>{
        setLesson(response.data);
        setLessonToEdit({...lessonToEdit, lessonName: response.data.lessonName, price: response.data.price});
        setLoaded(true);
    }).catch((error)=>{
      console.log(error);
      alert("هذا الدرس غير موجود");
      navigate(-1);
    })

  }

  useEffect(()=>{
    fetchData();
    setActive("المواد الدراسية");
    setMobileActive("courses mobile");
  },[reload])
  return (
    <div>
      {loaded &&(
        <div className="lesson-page">
          <div className="lesson-container">
            
            {/* Video + Details */}
            <div className="lesson-grid">
              {/* Video Section */}
                <iframe
                  className="lesson-video"
                  controls
                  title="الدرس"
                  controlsList="nodownload"
                  onContextMenu={(e) => e.preventDefault()}
                  src={lesson.url}
                  preload="metadata"
                />

              {/* Lesson Info */}
              <div className="lesson-info">
                <h1 className="lesson-title">اسم الدرس: {lesson.lessonName}</h1>

                <p><span className="label">التصنيف: </span>{lesson.category}</p>
                <p><span className="label">الصف : </span>{lesson.year}</p>
                <p><span className="label">الفصل : </span>{lesson.term}</p> {/* term */}
                <p><span className="label">المادة : </span>{lesson.courseName}</p> {/* course name */}
                <p><span className="label">اسم الوحدة: </span>{lesson.unitName}</p>
                <p><span className="label">الناشر : </span>{lesson.uploader}</p>
                <p><span className="label">تاريخ النشر : </span>{lesson.date}</p>
                <p><span className="label">عدد مرات الشراء : </span>{lesson.timesBuying}</p>
                <p><span className="label">السعر : </span>{lesson.price}</p>
                {/* Buttons */}
                <div className="lesson-actions">
                  <button className="btn btn-update" onClick={()=>{setShowEditLessonFrom(true)}}>تحديث</button>
                  <button className="btn btn-update" style={{display:`${lesson.price === 0?"none":"block"}`}} onClick={()=>{setShowCodePopup(true)}}>احصل علي كود</button>
                  <button className="btn btn-update" onClick={async ()=>{
                    const dataList = await getListOfQRCodes();
                    navigate(`/assistant-home/lesson/qr-codes/${id}`, {state:{lessonName: lesson.lessonName, dataList}})}}>QR أكواد</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showEditLessonFrom&&(
                    <div className="overlay">
                    <div className="add-new-lesson-form">
                        <h3>تعديل الدرس</h3>
                        <label>عنوان الدرس</label>
                        <input type="text" 
                        dir="rtl"
                        lang="ar"
                        value={lessonToEdit.lessonName}
                        className={showWarning?"wrong-field": ""}
                        onChange={(e)=>{setLessonToEdit({...lessonToEdit, lessonName: e.target.value});setShowWarning(false);setWarngin("")}}/>
                        {showWarning && (<p className="warning">{warning}</p>)}
                        <label>السعر</label>
                        <input type="number"
                        value={lessonToEdit.price}
                        onChange={(e)=>{setLessonToEdit({...lessonToEdit,price: e.target.value})}} />

                        <button className="add-new-folder-button" onClick={updateLesson}>تعديل</button>
                        <button className="add-new-folder-button" onClick={()=>{setShowEditLessonFrom(false);setReload(!reload)}}>إلغاء</button>
                    </div>
                    </div>
                )}

                {showCodesPopup&&(
                  <div className="overlay">
                    <div className="delete-lesson-folder-unit-form codes-div">
                      <h3 className="get-code-h3">الحصول علي اكواد جديدة</h3>
                      <h5 className="lesson-name" style={{textAlign:"right"}}>اسم الدرس: {lesson.lessonName} </h5>
                      <div>
                      <input type="number" dir="rtl" value={codesToGenerate} onChange={(e)=>setCodesToGenerate(e.target.value)} />
                      <label className="number-of-codes-lable">عدد الاكواد</label>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-around"}}>
                        <button style={{width:"fit-content"}} onClick={()=>{setShowCodePopup(false);setCodesToGenerate(0)}}>إغلاق</button>
                        <button style={{width:"fit-content"}} onClick={downloadCodes}>{getCodes? "⏳": 'احصل على الاكواد'}</button>
                      </div>
                    </div>
                  </div>
                )}

    </div>
  );
}
